import { Point } from "popmotion/lib/types";
import { SparseMap } from "../../lib/sparseMap";
import { Actor } from "../actors/Actor";
import { findActorForPosition, gameData } from "../GameManager";
import { countAdjacent, piecePos } from "../words/wordUtils";

export enum TargetTypes {
  NONE = "none",
  SELF = "self",
  DIRECTION = "direction",
  TARGET = "target",
  PIECE = "piece",
}

export type TargetOptions = {
  valid: boolean;
  actor?: Actor | null;
  letters?: string[];
  tile?: Point | null;
};

export class Target {
  type: TargetTypes = TargetTypes.NONE;
  passableOnly: boolean;
  noNeighbors: boolean;
  distance: number;
  prompt: string;
  promptProps?: Record<string, any>;
  requireActor?: boolean;

  constructor(data: any) {
    this.type = data.type || TargetTypes.NONE;
    this.passableOnly = data.passableOnly || true;
    this.noNeighbors = data.noNeighbors || false;
    this.distance = data.distance || 0;
    this.prompt = data.prompt;
    this.promptProps = data.promptProps;
    this.requireActor = data.requireActor;
  }

  validateRange(origins: Point[] | SparseMap<any, Point>, target: Point) {
    if (this.distance) {
      return (
        origins.find(
          (origin) =>
            Math.abs(origin.x - target.x) + Math.abs(origin.y - target.y) <=
            this.distance
        ) != null
      );
    }
    return true;
  }

  validateTileReqs(origins: Point[] | SparseMap<any, Point>, target: Point) {
    if (this.noNeighbors && countAdjacent(target)) {
      return "Target must not touch any pieces";
    }

    if (this.requireActor) {
      const piece = target ? gameData.pieces.get(piecePos(target)) : null;
      if (!piece) {
        return "Must Target an opponent";
      }
    }
  }

  validate(actor: Actor, pos?: Point): TargetOptions {
    let piece;
    switch (this.type) {
      case TargetTypes.TARGET:
        piece = pos ? gameData.pieces.get(piecePos(pos)) : null;
        return {
          valid: true,
          actor: piece ? gameData.actors.get(piece.owner) : null,
          tile: pos ? { x: pos.x, y: pos.y } : null,
        };
      default:
        return {
          valid: true,
          actor: actor,
          tile: pos ? { x: pos.x, y: pos.y } : null,
        };
    }
  }
}
